/* ============================================================
   Flamel Analytics — Theme dataLayer events
   Cliente: Redi Food (redifood.co)
   Generated: 2026-05-20 by flamel-analytics-dept WF-ANA-003
   Spec ref: clients/redifood/deliverables/2026-05-20/event-spec.json

   INSTALACIÓN:
   1. Subir este archivo a `assets/flamel-datalayer-events.js`
   2. En `layout/theme.liquid` antes del cierre </head> añadir:
      {{ 'flamel-datalayer-events.js' | asset_url | script_tag }}
   3. Asegurarse de que carga DESPUÉS del snippet de dataLayer init y del GTM snippet.

   ARQUITECTURA:
   - Eventos PDP/Collection se inyectan inline en sus respectivos templates
     (ver bloques de Liquid al final de este archivo, copiar a los templates).
   - Eventos de cart (add/remove/view) se interceptan via fetch monkey-patch
     y/o eventos custom del theme (cart:item-added, drawer:open).
   - Eventos del kit builder usan MutationObserver + delegación si la UI
     no expone eventos JS (fallback robusto).

   COMPATIBILIDAD: ES5+ — no dependencias externas. Funciona en Online Store 2.0
   (Dawn-based) y temas clásicos. No usa ES modules.
   ============================================================ */

(function() {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  /* Helper: push con reset previo del objeto ecommerce (Google recommended pattern) */
  function dlPush(eventName, ecommerce, extras) {
    window.dataLayer.push({ ecommerce: null });
    var payload = { event: eventName };
    if (ecommerce) payload.ecommerce = ecommerce;
    if (extras) {
      Object.keys(extras).forEach(function(k) { payload[k] = extras[k]; });
    }
    window.dataLayer.push(payload);
  }

  /* Helper: lee número desde string con formato de Shopify (admite "20.900,00" → 20900) */
  function parsePrice(raw) {
    if (typeof raw === 'number') return raw;
    if (!raw) return 0;
    /* Shopify usa cents internamente cuando el price viene de cart.js */
    var s = String(raw).replace(/[^\d.,-]/g, '').replace(',', '.');
    var n = parseFloat(s);
    return isNaN(n) ? 0 : n;
  }

  /* Helper: convierte cents (Shopify cart.js) a unidad principal */
  function fromCents(cents) {
    return typeof cents === 'number' ? cents / 100 : 0;
  }

  /* ========================================================
     1. ADD_TO_CART — intercept de /cart/add.js
     ======================================================== */

  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function(input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCartAdd = url.indexOf('/cart/add') !== -1;
      var isCartChange = url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1;

      return originalFetch.apply(this, arguments).then(function(response) {
        if (!response.ok) return response;

        var clone = response.clone();
        clone.json().then(function(data) {
          try {
            if (isCartAdd && data && (data.id || data.items)) {
              /* Soporta tanto el response item directo (data.id) como wrapped en data.items */
              var items = data.items || [data];
              var totalValue = 0;
              var ga4Items = items.map(function(it) {
                var price = fromCents(it.final_price || it.price || 0);
                var qty = it.quantity || 1;
                totalValue += price * qty;
                return {
                  item_id: String(it.product_id || it.id || ''),
                  item_name: it.product_title || it.title || '',
                  item_variant: it.variant_title || '',
                  item_brand: it.vendor || '',
                  item_category: it.product_type || '',
                  price: price,
                  quantity: qty
                };
              });

              /* Detectar si el item viene de un kit (kit_id persistido en sessionStorage) */
              var kitId = sessionStorage.getItem('flamel_kit_in_progress') || null;
              var extras = kitId ? { kit_id: kitId } : null;

              dlPush('add_to_cart', {
                currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'COP',
                value: totalValue,
                items: ga4Items
              }, extras);
            } else if (isCartChange && data && typeof data.item_count === 'number') {
              /* Cambio de cantidad — si quantity llegó a 0, es remove */
              /* Heurística: si el response cart tiene menos items, hubo remove */
              window.__flamelLastCartState = window.__flamelLastCartState || data.item_count;
              if (data.item_count < window.__flamelLastCartState) {
                fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart) {
                  /* No tenemos forma directa de saber QUÉ item se removió en /cart/change desde el response.
                     Lo más correcto sería emitir remove_from_cart desde un click handler en el botón "Quitar".
                     Como fallback, emitimos un evento con cart.total. */
                  dlPush('remove_from_cart', {
                    currency: cart.currency || 'COP',
                    value: fromCents(cart.total_price)
                  });
                });
              }
              window.__flamelLastCartState = data.item_count;
            }
          } catch(e) {
            console.error('[Flamel] cart event push error:', e);
          }
        }).catch(function(){ /* swallow JSON parse errors */ });

        return response;
      });
    };
  }

  /* ========================================================
     2. ADD_TO_CART — eventos custom del theme (Dawn / Online Store 2.0)
     Algunos themes emiten un CustomEvent cart:item-added en lugar de
     pasar por /cart/add.js. Suscribimos también ahí.
     ======================================================== */

  ['cart:item-added', 'product:added', 'product:added-to-cart'].forEach(function(eventName) {
    document.addEventListener(eventName, function(e) {
      try {
        var detail = e.detail || {};
        if (!detail.item && !detail.product) return;
        var item = detail.item || detail.product;
        var price = fromCents(item.final_price || item.price || 0);
        var qty = item.quantity || 1;
        dlPush('add_to_cart', {
          currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'COP',
          value: price * qty,
          items: [{
            item_id: String(item.product_id || item.id),
            item_name: item.product_title || item.title || '',
            item_variant: item.variant_title || '',
            price: price,
            quantity: qty
          }]
        });
      } catch(err) {
        console.error('[Flamel] add_to_cart custom event push error:', err);
      }
    });
  });

  /* ========================================================
     3. VIEW_CART — apertura del cart drawer
     ======================================================== */

  ['drawer:open', 'cart:open', 'cart-drawer:opened'].forEach(function(eventName) {
    document.addEventListener(eventName, function() {
      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart) {
        if (!cart || !cart.items) return;
        var ga4Items = cart.items.map(function(it) {
          return {
            item_id: String(it.product_id || it.id),
            item_name: it.product_title || it.title || '',
            item_variant: it.variant_title || '',
            price: fromCents(it.final_price || it.price || 0),
            quantity: it.quantity || 1
          };
        });
        dlPush('view_cart', {
          currency: cart.currency || 'COP',
          value: fromCents(cart.total_price),
          items: ga4Items
        });
      }).catch(function(){ /* swallow */ });
    });
  });

  /* Cart page (/cart) — fire on render */
  if (window.location.pathname === '/cart' || window.location.pathname.indexOf('/cart?') === 0) {
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart) {
      if (!cart || !cart.items || cart.items.length === 0) return;
      var ga4Items = cart.items.map(function(it) {
        return {
          item_id: String(it.product_id || it.id),
          item_name: it.product_title || it.title || '',
          price: fromCents(it.final_price || it.price || 0),
          quantity: it.quantity || 1
        };
      });
      dlPush('view_cart', {
        currency: cart.currency || 'COP',
        value: fromCents(cart.total_price),
        items: ga4Items
      });
    }).catch(function(){});
  }

  /* ========================================================
     4. SEARCH — submit del form de búsqueda
     ======================================================== */

  /* Buscar el form de search (Shopify estándar: action="/search" con name="q") */
  function attachSearchListener() {
    var forms = document.querySelectorAll('form[action="/search"], form[action*="/search"]');
    forms.forEach(function(form) {
      if (form.__flamelAttached) return;
      form.__flamelAttached = true;
      form.addEventListener('submit', function() {
        var input = form.querySelector('input[name="q"]');
        var q = input ? (input.value || '').trim() : '';
        if (!q) return;
        dlPush('search', null, { search_term: q });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachSearchListener);
  } else {
    attachSearchListener();
  }

  /* ========================================================
     5. VIEW_PROMOTION — IntersectionObserver sobre elementos con data-promo-id
     ======================================================== */

  if (typeof IntersectionObserver === 'function') {
    var promoObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
        var el = entry.target;
        if (el.__flamelPromoFired) return;
        el.__flamelPromoFired = true;
        dlPush('view_promotion', {
          promotion_id: el.getAttribute('data-promo-id') || '',
          promotion_name: el.getAttribute('data-promo-name') || '',
          creative_name: el.getAttribute('data-promo-creative') || '',
          creative_slot: el.getAttribute('data-promo-slot') || '',
          location_id: el.getAttribute('data-promo-location') || '',
          items: []
        });
        promoObserver.unobserve(el);
      });
    }, { threshold: 0.5 });

    function attachPromoObserver() {
      document.querySelectorAll('[data-promo-id]').forEach(function(el) {
        promoObserver.observe(el);
        /* select_promotion en click */
        el.addEventListener('click', function() {
          dlPush('select_promotion', {
            promotion_id: el.getAttribute('data-promo-id') || '',
            promotion_name: el.getAttribute('data-promo-name') || '',
            creative_name: el.getAttribute('data-promo-creative') || '',
            creative_slot: el.getAttribute('data-promo-slot') || '',
            location_id: el.getAttribute('data-promo-location') || '',
            items: []
          });
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attachPromoObserver);
    } else {
      attachPromoObserver();
    }
  }

  /* ========================================================
     6. KIT BUILDER — eventos custom kit_builder_*
     ========================================================
     ESTRATEGIA: dado que la implementación específica del configurador
     "¡Arma tu kit!" en redifood.co no está confirmada (puede ser section
     custom, app de Shopify, o iframe), implementamos un patrón híbrido:

     OPCIÓN A — si el theme expone hooks JS (preferida):
       En el theme/app del kit, emitir CustomEvents:
         document.dispatchEvent(new CustomEvent('flamel:kit:start', {detail: {kit_type: '...'}}))
         document.dispatchEvent(new CustomEvent('flamel:kit:add', {detail: {item: ..., total: ...}}))
         document.dispatchEvent(new CustomEvent('flamel:kit:remove', {detail: {item: ..., total: ...}}))
         document.dispatchEvent(new CustomEvent('flamel:kit:complete', {detail: {items: ..., total: ...}}))

     OPCIÓN B — sin hooks (fallback):
       MutationObserver sobre el DOM del configurador, identificando
       cambios en cantidad de items (data-kit-item count). Menos preciso
       pero funcional. Requiere identificar selectores CSS específicos
       del configurador de Redi Food en Fase 4.

     Aquí dejamos los listeners para OPCIÓN A. La OPCIÓN B fallback
     se añade tras inspeccionar redifood.co en Fase 4 si OPCIÓN A no aplica.
  */

  function genKitId() {
    return 'kit_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
  }

  document.addEventListener('flamel:kit:start', function(e) {
    var d = e.detail || {};
    var kitId = genKitId();
    sessionStorage.setItem('flamel_kit_in_progress', kitId);
    sessionStorage.setItem('flamel_kit_type', d.kit_type || '');
    sessionStorage.setItem('flamel_kit_step', '0');
    sessionStorage.setItem('flamel_kit_items_count', '0');
    sessionStorage.setItem('flamel_kit_value', '0');
    dlPush('kit_builder_start', null, {
      kit_id: kitId,
      kit_type: d.kit_type || ''
    });
  });

  document.addEventListener('flamel:kit:add', function(e) {
    var d = e.detail || {};
    var kitId = sessionStorage.getItem('flamel_kit_in_progress') || genKitId();
    var count = parseInt(sessionStorage.getItem('flamel_kit_items_count') || '0', 10) + 1;
    var step = parseInt(sessionStorage.getItem('flamel_kit_step') || '0', 10) + 1;
    var total = parsePrice(d.total);
    sessionStorage.setItem('flamel_kit_items_count', String(count));
    sessionStorage.setItem('flamel_kit_step', String(step));
    sessionStorage.setItem('flamel_kit_value', String(total));
    dlPush('kit_builder_add_item', d.ecommerce || null, {
      kit_id: kitId,
      kit_type: sessionStorage.getItem('flamel_kit_type') || '',
      kit_step: step,
      items_count: count,
      kit_value: total
    });
  });

  document.addEventListener('flamel:kit:remove', function(e) {
    var d = e.detail || {};
    var kitId = sessionStorage.getItem('flamel_kit_in_progress') || '';
    var count = Math.max(0, parseInt(sessionStorage.getItem('flamel_kit_items_count') || '0', 10) - 1);
    var total = parsePrice(d.total);
    sessionStorage.setItem('flamel_kit_items_count', String(count));
    sessionStorage.setItem('flamel_kit_value', String(total));
    dlPush('kit_builder_remove_item', null, {
      kit_id: kitId,
      items_count: count,
      kit_value: total
    });
  });

  document.addEventListener('flamel:kit:complete', function(e) {
    var d = e.detail || {};
    var kitId = sessionStorage.getItem('flamel_kit_in_progress') || '';
    var count = parseInt(sessionStorage.getItem('flamel_kit_items_count') || '0', 10);
    var total = parsePrice(d.total);
    var kitType = sessionStorage.getItem('flamel_kit_type') || '';
    dlPush('kit_builder_complete', {
      currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'COP',
      value: total,
      items: d.items || []
    }, {
      kit_id: kitId,
      kit_type: kitType,
      items_count: count,
      kit_value: total
    });
    /* kit_id persiste en sessionStorage → se mantiene en el add_to_cart subsiguiente
       y en el purchase final (Customer Events). */
  });

  /* Abandono por timeout o visibility change */
  var KIT_ABANDON_TIMEOUT_MS = 60 * 1000;
  var kitAbandonTimer = null;

  function startKitAbandonTimer() {
    if (kitAbandonTimer) clearTimeout(kitAbandonTimer);
    kitAbandonTimer = setTimeout(function() {
      fireKitAbandon('timeout');
    }, KIT_ABANDON_TIMEOUT_MS);
  }

  function fireKitAbandon(reason) {
    var kitId = sessionStorage.getItem('flamel_kit_in_progress');
    if (!kitId) return;
    var count = parseInt(sessionStorage.getItem('flamel_kit_items_count') || '0', 10);
    var step = parseInt(sessionStorage.getItem('flamel_kit_step') || '0', 10);
    var total = parsePrice(sessionStorage.getItem('flamel_kit_value') || '0');
    dlPush('kit_builder_abandon', null, {
      kit_id: kitId,
      kit_type: sessionStorage.getItem('flamel_kit_type') || '',
      kit_step: step,
      items_count: count,
      kit_value: total,
      abandon_reason: reason
    });
    /* Limpiar sessionStorage al abandonar */
    sessionStorage.removeItem('flamel_kit_in_progress');
    sessionStorage.removeItem('flamel_kit_type');
    sessionStorage.removeItem('flamel_kit_step');
    sessionStorage.removeItem('flamel_kit_items_count');
    sessionStorage.removeItem('flamel_kit_value');
  }

  /* Reiniciar timer en cualquier interacción dentro del kit builder */
  ['flamel:kit:add', 'flamel:kit:remove'].forEach(function(ev) {
    document.addEventListener(ev, startKitAbandonTimer);
  });
  document.addEventListener('flamel:kit:start', startKitAbandonTimer);

  /* Limpiar timer en complete */
  document.addEventListener('flamel:kit:complete', function() {
    if (kitAbandonTimer) clearTimeout(kitAbandonTimer);
  });

  /* visibility change → abandono */
  document.addEventListener('visibilitychange', function() {
    if (document.hidden && sessionStorage.getItem('flamel_kit_in_progress')) {
      fireKitAbandon('visibility_hidden');
    }
  });

})();

/* ============================================================
   ANEXO — Bloques Liquid para pegar en templates específicos
   ============================================================
   Estos bloques se inyectan en los templates correspondientes
   (no van en este JS — son snippets para Liquid).

   PEGAR EN: sections/main-product.liquid (o equivalente PDP)
   ANTES de cerrar la section principal, dentro de <script>:

   {% comment %} Flamel — view_item event {% endcomment %}
   <script>
   window.dataLayer = window.dataLayer || [];
   window.dataLayer.push({ ecommerce: null });
   window.dataLayer.push({
     event: 'view_item',
     ecommerce: {
       currency: '{{ cart.currency.iso_code | default: shop.currency }}',
       value: {{ product.price | divided_by: 100.0 }},
       items: [{
         item_id: '{{ product.id }}',
         item_name: {{ product.title | json }},
         item_brand: {{ product.vendor | json }},
         item_category: {{ product.type | json }},
         item_variant: {{ product.selected_or_first_available_variant.title | json }},
         price: {{ product.price | divided_by: 100.0 }},
         quantity: 1
       }]
     }
   });
   </script>

   ----

   PEGAR EN: sections/main-collection-product-grid.liquid
   (o template de colección) — DESPUÉS del loop de productos:

   {% comment %} Flamel — view_item_list event {% endcomment %}
   <script>
   window.dataLayer = window.dataLayer || [];
   window.dataLayer.push({ ecommerce: null });
   window.dataLayer.push({
     event: 'view_item_list',
     ecommerce: {
       item_list_id: '{{ collection.handle }}',
       item_list_name: {{ collection.title | json }},
       items: [
         {%- for product in collection.products limit: 24 -%}
         {
           item_id: '{{ product.id }}',
           item_name: {{ product.title | json }},
           item_brand: {{ product.vendor | json }},
           item_category: {{ product.type | json }},
           price: {{ product.price | divided_by: 100.0 }},
           index: {{ forloop.index0 }}
         }{% unless forloop.last %},{% endunless %}
         {%- endfor -%}
       ]
     }
   });

   // select_item — delegated click sobre product cards
   document.querySelectorAll('[data-product-card]').forEach(function(card){
     card.addEventListener('click', function(){
       window.dataLayer.push({ ecommerce: null });
       window.dataLayer.push({
         event: 'select_item',
         ecommerce: {
           item_list_id: '{{ collection.handle }}',
           item_list_name: {{ collection.title | json }},
           items: [{
             item_id: card.getAttribute('data-product-id'),
             item_name: card.getAttribute('data-product-title')
           }]
         }
       });
     });
   });
   </script>

   Si los product cards no tienen data-attributes, añadirlos en el card snippet:
     <div class="product-card" data-product-card
          data-product-id="{{ product.id }}"
          data-product-title="{{ product.title | escape }}">

   ============================================================
*/
